// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"f1ba7901","79":"fbc9c195","119":"1cb936de","264":"0067fde1","371":"03ae86f7","511":"677643cb","786":"09d8235f","915":"b4e6bd26"}[chunkId] + ".chunk.js";
};